module.exports = __webpack_public_path__ + "img/pijltje-blauw-links.e8f6eca104e79feec308fc66b8f91495.svg";